'use client';

import { EarningsYieldValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  values: EarningsYieldValues;
  onValuesChange: (field: keyof EarningsYieldValues, value: number) => void;
  translations: ToolsTranslations['earningsYield'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const handleChange = (field: keyof EarningsYieldValues) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\s/g, '').replace(/,/g, '.');
    const value = Number(raw);
    onValuesChange(field, isNaN(value) ? 0 : value);
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.pricePerShare}</label>
        <input type="text" value={values.pricePerShare} onChange={handleChange('pricePerShare')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.epsAfterTax}</label>
        <input type="text" value={values.epsAfterTax} onChange={handleChange('epsAfterTax')} className={inputClass} placeholder="0" />
      </div>
    </div>
  );
}


